export default __webpack_public_path__ + "static/media/old CI.3daad89a.svg";